import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BadgesComponent } from '@enginuity/core/molecules/badges/badges.component';
import { IconBtnComponent } from '@enginuity/core/molecules/icon-btn/icon-btn.component';
import { SecondaryBtnsComponent } from '@enginuity/core/molecules/secondary-btns/secondary-btns.component';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { ActionBtnComponent } from '@enginuity/core/molecules/action-btn/action-btn.component';
import { Router } from '@angular/router';

import { ToggleComponent } from '@enginuity/core/molecules/toggle/toggle.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CdkConnectedOverlay, OverlayModule, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ShippingTooltipComponent } from '@enginuity/core/molecules/shipping-tooltip/shipping-tooltip.component';
import { DropdownSinglePieceComponent } from '@enginuity/core/molecules/dropdown-single-piece/dropdown-single-piece.component';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { SearchComponent } from '@enginuity/core/molecules/search/search.component';
import { DatatypesComponent } from '@enginuity/core/atoms/datatypes/datatypes.component';
import { IconContainerComponent } from '@enginuity/core/atoms/icon-container/icon-container.component';
import { InputWrapperComponent } from '@enginuity/core/organisms/input-wrapper/input-wrapper.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { AvatarIconComponent } from '@enginuity/core/molecules/avatar-icon/avatar-icon.component';
import { MatTooltipModule, type MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: '[app-table-data]',
  templateUrl: './table-data.component.html',
  styleUrls: ['./table-data.component.scss'],
  imports: [
    CommonModule,
    IconBtnComponent,
    BadgesComponent,
    SecondaryBtnsComponent,
    CeIconComponent,
    ActionBtnComponent,

    CdkMenuTrigger,
    CdkMenu,
    CdkMenuItem,
    ToggleComponent,
    OverlayModule,
    MatProgressBarModule,
    ShippingTooltipComponent,
    DropdownSinglePieceComponent,
    SearchComponent,
    DatatypesComponent,
    IconContainerComponent,
    InputWrapperComponent,
    ClipboardModule,
    CdkConnectedOverlay,
    AvatarIconComponent,
    MatTooltipModule,
  ],
})
export class TableDataComponent {
  value = 70;
  isOpen: boolean = false;
  displayedSegmentsLimit = 1;
  @ViewChild('tooltip') tooltip!: MatTooltip;

  // @Input() copy(text: string) {}
  @Output() onChange = new EventEmitter<string | string[] | boolean | any>();

  @Output() onClick = new EventEmitter<object>();
  @Output() btnClick = new EventEmitter<object>();
  @Output() onActions = new EventEmitter<any>();
  isStatus = false;
  @ViewChild('trigger', { static: false }) trigger!: CdkOverlayOrigin;
  onStatus() {
    this.isOpen = !this.isOpen;
  }

  onStock() {
    this.isOpen = !this.isOpen;
  }

  onSearch(event?: string) {}
  @Input()
  Type: string = 'actions';
  constructor(private router: Router) {}

  actionClick(action: any, dropdownItem?: any) {
    const eventPayload = dropdownItem
      ? { action: dropdownItem.action, value: dropdownItem.value, parentAction: action }
      : action;

    this.onClick.emit(eventPayload);
  }

  @Input() copy(copymode: boolean): void {
    if (copymode) {
      this.tooltip.show();
    }
  }

  customClick(list: any) {
    if (list.link) {
      this.router.navigateByUrl(list.link);
    } else {
      this.onClick.emit(list);
    }
  }
  stars = Array(5).fill(0);
  rate(newRate: number): void {
    if (!this.data[this.Type]['readonly']) {
      this.data[this.Type]['currentRate'] = newRate; // Update the rating
    }
  }

  @Input()
  data: any = {
    customer: {
      name: 'John',
    },
    customers: {
      users: [
        {
          name: 'John',
          image: '/assets/avatar.png',
        },
        {
          name: 'John',
          image: '/assets/avatar.png',
        },
        {
          name: 'John',
          image: '/assets/avatar.png',
        },
        {
          name: 'John',
          image: '/assets/avatar.png',
        },
      ],
    },
    campaign: {
      campaign_name: 'Campaign name',
      description: 'Help new customers understand the value they’ll receive from your product.',
    },
    toggle: {
      active: false,
    },
    avataar: {
      seed: 'name1',
      size: '150',
    },
    orders: {
      number: 'OD1212132DSD212',
      storeIcons: 'amazon',
      badge_label: 'Super saver price',
      badge_type: 'completed',
      badge_icon: 'no_icon',
    },
    settlement: {
      order_price: '₹ 38,808',
      settle_price: '/ 77,616',
      label: 'Super saver price',
      Type: 'completed',
      IconType: 'no_icon',
    },
    button: {
      button_label: 'Change',
    },
    product: {
      product_img: '/assets/product.jpg',
      product_name: 'Product name',
      color: '',
      strike: '',
      status: {
        label: '',
        status_type: '',
        IconType: '',
      },
    },
    input: {
      inputType: 'text',
      stepCounter: false,
      prefix: false,
      multiSelectTags: false,
      multiSelect: false,
      prefixContent: { icon: 'down_arrow', type: 'white', label: '%' },
      sufix: false,
      sufixContent: { icon: 'down_arrow', type: 'white', label: 'units' },
      placeholder: 'placeholder',
      conditionLabel: '',
      state: 'default',
      conditionText: 'Up to',
    },
    attribute: {
      dataType: 'string_text',
      title: 'Text',
    },
    progressBar: {
      title: 'To be shipped',
      value: 70,
      progressColor: 'primary-100',
    },
    tier: {
      icon: 'person',
      title: 'Gold',
    },
    rating: {
      currentRate: 4,
      readonly: true,
    },
    statusDate: {
      date: '03/12/2022',
      status: {
        label: 'Super saver price',
        statusType: 'completed',
        IconType: 'no_icon',
      },
      sloStatus: [
        {
          label: 'Expected',
          date: 'Jan 2, 2022',
        },
        {
          label: 'Actual',
          date: 'Jan 2, 2022',
        },
        {
          label: 'Difference',
          date: 'On time',
        },
      ],
    },
    status: {
      label: 'Super saver price',
      Type: 'completed',
      IconType: 'no_icon',
      uppercase: false,
      copymode: false,
    },
    shipmentStatus: {
      label: 'Super saver price',
      Type: 'completed',
      IconType: 'no_icon',
      shipping: [
        {
          label: 'Order date',
          status: { status_type: 'white', date: 'June 24,  2023' },
        },
        {
          label: 'Packed',
          status: { status_type: 'completed', date: 'June 24,  2023' },
        },
        {
          label: 'Dispatched',
          status: { status_type: 'cancelled', date: 'June 26,  2023' },
        },
        {
          label: 'Delivered',
          status: { status_type: 'cancelled', date: 'June 26,  2023' },
        },
      ],
    },
    shipmentStock: {
      label: 'Super saver price',
      Type: 'completed',
      IconType: 'no_icon',
      stock: [
        {
          label: 'Paris Warehouse',
          type: 'tag',
          icon: 'channel',
          date: '301',
        },
        {
          label: 'Sanat Teppiche Asia',
          type: 'cancelled',
          icon: 'no_icon',
          date: 'Out of stock',
        },
      ],
    },
    product_details: {
      product_img: '/assets/product.jpg',
      product_name: 'Sunglasses',
      price: '$20.00',
      stock: 'in stock',
      active: 'inactive',
      color: '',
    },
    order_w_icons: {
      iconContainer: 'warehouse',
      showIcon: true,
      showChannel: true,
      storeIcons: 'amazon',
      product_name: 'Sunglasses',
      price: '$20.00',
      stock: 'in stock',
      active: 'inactive',
      color: '',
    },
    text: {
      title: 'text here',
      cursor: '',
      color: '',
      strike: '',
      icon: '',
      status: {
        label: '',
        status_type: '',
        IconType: '',
      },
    },
    left_icon: {
      title: 'text here',
      cursor: '',
      color: '',
      strike: '',
      icon: 'settings',
    },
    right_icon: {
      title: 'text here',
      cursor: '',
      color: '',
      strike: '',
      icon: 'settings',
    },
    location: {
      location_img: '/assets/location.png',
      location_name: 'United States',
    },
    string: {
      title: 'text here',
    },
    segments: [
      {
        icon: 'convert',
        segmentName: 'Email',
        active: false,
      },
    ],
    channel: [
      {
        icon: 'convert',
        channelName: 'Email',
        active: false,
      },
      {
        icon: 'convert',
        channelName: 'Mobile',
        active: false,
      },
      {
        icon: 'convert',
        channelName: 'Mobile',
        active: false,
      },
    ],
    actions: [
      {
        icon: 'more',
        text: '',
        active: false,
        dropdown: [
          {
            label: 'Export',
            icon: 'no_icon',
            color: 'default',
          },
        ],
      },
      {
        icon: 'chevron_right',
        text: '',
        active: false,
      },
    ],
  };

  showDropdown(action: any): boolean {
    return action.dropdown !== undefined && action.dropdown !== null;
  }

  // showList(action: any): boolean {
  //   return action.dropdown !== undefined && action.dropdown !== null;
  // }
}
